document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('[data-custom-purchase-cards]');
  var nativePicker = document.querySelector('[data-native-variant-picker] variant-radios, [data-native-variant-picker] variant-selects');
  if (!wrapper || !nativePicker) return;

  var variantsJsonEl = nativePicker.querySelector('script[type="application/json"]');
  var variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];
  var fieldsets = nativePicker.querySelectorAll('.variant-input-wrapper');

  wrapper.addEventListener('change', function (e) {
    if (e.target.name !== 'custom-purchase-option') return;
    var variantId = e.target.value;

    wrapper.querySelectorAll('.purchase-card').forEach(function (card) {
      card.classList.toggle('is-selected', card.dataset.variantId === variantId);
    });

    var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
    if (!variant) return;

    variant.options.forEach(function (optionValue, i) {
      var fieldset = fieldsets[i];
      if (!fieldset) return;
      var radio = fieldset.querySelector('input[value="' + CSS.escape(optionValue) + '"]');
      var select = fieldset.querySelector('select');
      if (radio) {
        radio.checked = true;
      } else if (select) {
        select.value = optionValue;
      }
    });

    // Dispara el listener de Dawn/Be Yours directamente en el componente,
    // que relee todos los inputs del fieldset y actualiza precio/ATC/URL
    nativePicker.dispatchEvent(new Event('change', { bubbles: true }));
  });
});